import React from 'react';
import { ZapIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-white px-6 py-20 sm:py-24" aria-labelledby="problema-titulo" data-id="element-151" data-mp="2ltwb9qt06gw1">
      <div className="mx-auto max-w-6xl" data-id="element-152" data-mp="30hzfaunhjii7">
        <div className="mx-auto max-w-3xl text-center" data-id="element-153" data-mp="2vqhgac50vrzv">
          <h2 id="problema-titulo" className="font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl lg:text-[2.75rem]" data-id="element-154" data-mp="2vowm4nmmeb2j">
            ¿Cuántas clases más vas a preparar sobre Instrumentación sin tener el sistema completo?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-forest-700/75" data-id="element-155" data-mp="3jeqy72z47vlq">
            Buscás contenido actualizado sin encontrar referencias claras. Y cuando un alumno pregunta sobre
            Industria 4.0, protocolos WirelessHART o cómo funciona el Edge Computing en la medición real, no
            tenés dónde buscar respuestas técnicas verificadas.
          </p>
          <p className="mt-6 inline-flex items-start gap-3 rounded-2xl bg-ember-50 px-5 py-4 text-left text-base font-medium text-ember-600" data-id="element-156" data-mp="jdn5w5thx25z">
            <ZapIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-157" data-mp="ocpxookgtbw0" />
            No es falta de experiencia docente. Es que el material de instrumentación moderna no existe
            compilado en un solo lugar.
          </p>
        </div>

        <h3 className="mt-16 text-center font-display text-2xl font-semibold text-forest-800" data-id="element-158" data-mp="123v203ys2sco">
          Esto quizás te está pasando hoy:
        </h3>

        <ul className="mt-10 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-159" data-mp="170uypo9qmir4">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full flex-col border-t border-cream-200 pt-6" data-id="element-160" data-mp="1g3w39kiyg1so">
              <Icon className="h-6 w-6 text-ember-500" aria-hidden="true" data-id="element-161" data-mp="3dtnnw3626t4i" />
              <h4 className="mt-4 font-display text-xl font-semibold text-forest-800" data-id="element-162" data-mp="3dviarn0w4vb8">{title}</h4>
              <p className="mt-2 text-base leading-relaxed text-forest-700/70" data-id="element-163" data-mp="3hwk9m2qwb5co">{description}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-16 max-w-3xl text-center font-display text-2xl font-semibold italic leading-snug text-forest-700 sm:text-3xl" data-id="element-164" data-mp="k1z6hikysbtz">
          ¿Y si esta fuera la última semana que enseñás Instrumentación sin tener el ecosistema completo?
        </p>
      </div>
    </section>;
}